const email =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const phone = /^\d{6,13}$/;
const orgNumberNorway = /^\d{9}$/;
const orgNumberSweden = /^\d{10}$/;
const numbersOnly = /^\d+$/;
const countryCode = /^(\+)(\d{1,3})$/;

const RegEx = {
  email,
  phone,
  countryCode,
  orgNumberNorway,
  orgNumberSweden,
  numbersOnly,
};

export default RegEx;
